/**
 * Cliente de Lemon Slice — capa de video del avatar (lip-sync server-side
 * sobre Daily.co). Lemon Slice no maneja LLM/STT/TTS — eso lo hace tu
 * pipeline existente (LangGraph + /api/tts). Este servicio solo:
 *
 *   1. Pide al backend que cree una sala Daily.co self-managed
 *      (POST /api/lemonslice/room).
 *   2. El componente <LemonSliceAvatar> se une "headless" a esa sala
 *      y publica el audio TTS como track propio para que Lemon Slice
 *      genere el video con lip-sync.
 *
 * Si REACT_APP_LEMONSLICE_ENABLED no está a "true" el servicio se considera
 * deshabilitado y la UI cae al placeholder animado (o al VideoAvatar si
 * está habilitado).
 */

const LS_BASE = process.env.REACT_APP_API_URL || 'http://localhost:7072/api';
const AGENT_ID = process.env.REACT_APP_LEMONSLICE_AGENT_ID || '';

export const isLemonSliceEnabled = () => process.env.REACT_APP_LEMONSLICE_ENABLED === 'true';

/**
 * Crea una sala self-managed y devuelve { room_url, session_id }.
 * La API key de Lemon Slice vive en el server, nunca en el bundle.
 */
export async function createLemonSliceRoom({ agentId } = {}) {
    const body = {};
    const aid = agentId || AGENT_ID;
    if (aid) body.agent_id = aid;

    const res = await fetch(`${LS_BASE}/lemonslice/room`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        let detail = '';
        try { detail = JSON.stringify(await res.json()); } catch (_) {}
        throw new Error(`Lemon Slice room ${res.status} ${detail}`);
    }
    return res.json();
}

const lemonsliceService = {
    isLemonSliceEnabled,
    createLemonSliceRoom,
};

export default lemonsliceService;